(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-appointment"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-calendar"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-event"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-location"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-performer"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-tab-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  const mqMobile = window.matchMedia('(max-width: 989px)');

  const galleryTextSlide = (root = document) => {
    const cards = Array.from(root.querySelectorAll('.gallery-with-text__card'));
    if (!cards.length) return;

    let activeCard = null;

    const setOverlayState = () => {
      cards.forEach(c => {
        const overlay = c.querySelector('.gallery-with-text__info .link--overlay');
        if (!overlay) return;
        overlay.classList.toggle('active', c === activeCard);
      });
    };

    // --- MOBILE height logic ---
    const getHeights = (card) => {
      const title = card.querySelector('.gallery-with-text__title');
      const info  = card.querySelector('.gallery-with-text__info');

      const titleH = title ? title.offsetHeight : 0;
      const infoH  = info ? info.scrollHeight : 0;

      const collapsed = Math.max(titleH, 72);
      const expanded  = titleH + infoH + 2;

      return { collapsed, expanded };
    };

    const applyHeights = () => {
      if (!mqMobile.matches) return;

      cards.forEach(card => {
        const { collapsed, expanded } = getHeights(card);
        card.style.setProperty('--collapsed-h', collapsed + 'px');
        card.style.maxHeight = (card === activeCard ? expanded : collapsed) + 'px';
      });
    };

    const clearMobileHeights = () => {
      cards.forEach(card => {
        card.style.removeProperty('max-height');
        card.style.removeProperty('--collapsed-h');
      });
    };

    const setActive = (card) => {
      if (!card) return;
      activeCard = card;

      cards.forEach(c => c.classList.toggle('active', c === activeCard));
      setOverlayState();

      if (mqMobile.matches) applyHeights();
      else clearMobileHeights();
    };

    const closeAll = () => {
      activeCard = null;
      cards.forEach(c => c.classList.remove('active'));
      setOverlayState();
      if (mqMobile.matches) {
        // collapse all to header height
        cards.forEach(card => {
          const { collapsed } = getHeights(card);
          card.style.setProperty('--collapsed-h', collapsed + 'px');
          card.style.maxHeight = collapsed + 'px';
        });
      }
    };

    // INIT:
    // On mobile: default open first tab (unless one is pre-marked active in editor)
    // On desktop: keep your existing "active" if set, else first.
    const preActive = root.querySelector('.gallery-with-text__card.active') || cards[0];
    setActive(preActive);

    // DESKTOP behavior: hover to activate (as before)
    if (!mqMobile.matches) {
      cards.forEach(card => {
        card.addEventListener('mouseenter', function () {
          setActive(this);
        });
      });
    }

    // MOBILE behavior: tap header toggles open/close
    const bindMobileToggles = () => {
      if (!mqMobile.matches) return;

      // ensure heights are set on mobile
      applyHeights();

      cards.forEach(card => {
        const title = card.querySelector('.gallery-with-text__title');
        if (!title) return;

        // Prevent double-binding if theme re-inits
        if (title.dataset.gwtBound === 'true') return;
        title.dataset.gwtBound = 'true';

        title.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // toggle
          if (card === activeCard) {
            // close current (optional: keep at least one open by default)
            // If you ALWAYS want one open, comment out closeAll() and just return.
            closeAll();
          } else {
            setActive(card);
          }
        });
      });
    };

    bindMobileToggles();

    // On resize across breakpoint: clean up + re-apply appropriate layout
    window.addEventListener('resize', () => {
      if (mqMobile.matches) {
        // entering mobile: if nothing active, open first
        if (!activeCard) setActive(cards[0]);
        applyHeights();
        bindMobileToggles();
      } else {
        // entering desktop: remove mobile max-heights
        clearMobileHeights();
      }
    });

    // Recalc after images load (mobile heights depend on content)
    window.setTimeout(() => { if (mqMobile.matches) applyHeights(); }, 150);
    window.setTimeout(() => { if (mqMobile.matches) applyHeights(); }, 500);
  };

  document.addEventListener('shopify:section:load', (e) => {
    galleryTextSlide(e.target);
  });

  galleryTextSlide();
})();

  } catch(e) { console.error(e); }
})();
})();
